<template>
  <section id="change">
    <b-container style="margin-top: 0; margin-bottom: 0">
      <b-row>
        <b-col cols="12" md="12" lg="12" align="center">
          <h3>
            {{ $t('change.title') }}
          </h3>
          </b-col>
        </b-row>
      </b-container>
    <b-container>
      <b-row>
        <b-col cols="12" md="12" lg="6">
          <img class="img img__shadowed" style="margin-top: 0.8rem" src="@/assets/bgrnd7.jpg" alt />
        </b-col>
        <b-col cols="12" md="12" lg="6">
          <p class="d-block d-lg-block">{{ $t('change.paragraph1') }}</p>
          <p class="d-block d-lg-block">{{ $t('change.paragraph2') }}</p>
          <p class="d-block d-lg-block">{{ $t('change.paragraph3') }}</p>
          <p class="d-block d-lg-block">{{ $t('change.paragraph4') }}</p>
        </b-col>
        </b-row>
      <b-row style="margin-top: 1rem">
        <b-col cols="12" md="6" lg="6">  
          <p class="d-block d-lg-block">{{ $t('change.sellTitle') }}
            <ul>
            <li>{{ $t('change.sellStep1') }}</li>
            <li>{{ $t('change.sellStep2') }}</li>
            <li>{{ $t('change.sellStep3') }}</li>
            <li>{{ $t('change.sellStep4') }}</li>
            </ul></p>
        </b-col>
        <b-col cols="12" md="6" lg="6">
          <p class="d-block d-lg-block">{{ $t('change.buyTitle') }}
            <ul>
            <li>{{ $t('change.buyStep1') }}</li>
            <li>{{ $t('change.buyStep2') }}</li>
            <li>{{ $t('change.buyStep3') }}</li>
            <li>{{ $t('change.buyStep4') }}</li>
            </ul></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" lg="12">
        <p class="d-block d-lg-block">{{ $t('change.details') }}</p>
        </b-col>
        </b-row>
      <b-row>
        <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" align="center">
          <a
            class="btn btn__primary"
            href="https://telegram.me/MoneyCashBit"
            target="_blank"
          >{{ $t('common.telegramCta') }}</a>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang='sass'>
.info
  .btn__primary
    width: 40%
</style>